import React from 'react';

const Error = () => {
  return (
    <section id="contact-a" className="text-center py-3">
      <div className="container">
        <h2 className="section-title">Error 404</h2>
        <div className="bottom-line"></div>
        <p className="lead">Page does not exist!</p>
      </div>
    </section>
  );
};

export default Error;
